<template>
    <cic-popup
        :title="item.accountId ? $t('Edit Viber Account') : $t('New Viber Account')"
        :saveable="$store.hasRight('EDIT_ACCESS_TYPE_20')"
        @blur="$emit('blur')"
        @input="validate"
    >
        <div class="item-form">
            <ul style="display: grid">
                <li class="form-item-centred">
                    <div class="form-label-first">{{ $t('Name') }}:</div>
                    <div>
                        <cic-textbox
                            id="accountName"
                            :value="item.accountName"
                            :class="{ highlight: accountNameInvalid }"
                            :placeholder="$t('Label for Viber account')"
                            @input="(val) => updateFieldValue('accountName', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('Access Token') }}:</div>
                    <div>
                        <cic-textbox
                            id="accessToken"
                            :value="item.accessToken"
                            :class="{ highlight: tokenInvalid }"
                            :placeholder="$t('Token from Viber admin panel')"
                            @input="(val) => updateFieldValue('accessToken', val)"
                        />
                    </div>
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditViberAccount',
        components: {
            CicTextbox,
            CicPopup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                accountNameInvalid: false,
                tokenInvalid: false,
            };
        },
        methods: {
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },

            validate() {
                this.accountNameInvalid = this.item.accountName.trim() === '';
                this.tokenInvalid = this.item.accessToken.trim() === '';

                if (this.accountNameInvalid || this.pageIdInvalid) {
                    return;
                }

                this.$emit('input');
            },
        },
    };
</script>
